export default "__VITE_ASSET__Bm8y9Txe__"